import { FUND, SECURITYLIST_GROUP_MULTI } from 'Angular/constants/core.constants';
import { FUND_CALC } from 'CalculationsApp/ts/constants/calc-search-types.constants';
import { UniverseQuartileChartFrequency } from 'ChartApp/ts/features/universe-quartile-chart/constants';
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
/**
 * Zooms `UniverseQuartileChartDateZoom` accepts, in the order the control lists them.
 *
 * Deliberately not `VALID_FUND_CHART_DATE_ZOOM_OPTIONS`: that one offers 1d, 5d, YTD and Max,
 * none of which the endpoint accepts, and omits the 2y and 15y that it does.
 */
export const UNIVERSE_QUARTILE_ZOOM_OPTIONS = [
    { label: '1m', value: ChartDateZoom.CHART_ZOOM_ONE_MONTH, enabled: true },
    { label: '3m', value: ChartDateZoom.CHART_ZOOM_THREE_MONTH, enabled: true },
    { label: '6m', value: ChartDateZoom.CHART_ZOOM_SIX_MONTH, enabled: true },
    { label: '1y', value: ChartDateZoom.CHART_ZOOM_ONE_YEAR, enabled: true },
    { label: '2y', value: ChartDateZoom.CHART_ZOOM_TWO_YEAR, enabled: true },
    { label: '3y', value: ChartDateZoom.CHART_ZOOM_THREE_YEAR, enabled: true },
    { label: '5y', value: ChartDateZoom.CHART_ZOOM_FIVE_YEAR, enabled: true },
    { label: '10y', value: ChartDateZoom.CHART_ZOOM_TEN_YEAR, enabled: true },
    { label: '15y', value: ChartDateZoom.CHART_ZOOM_FIFTEEN_YEAR, enabled: true },
];
/** How long each zoom spans, as `UniverseQuartileChartParams.ZOOM_REGEX` reads it. */
export const ZOOM_YEARS = {
    [ChartDateZoom.CHART_ZOOM_ONE_MONTH]: 1 / 12,
    [ChartDateZoom.CHART_ZOOM_THREE_MONTH]: 0.25,
    [ChartDateZoom.CHART_ZOOM_SIX_MONTH]: 0.5,
    [ChartDateZoom.CHART_ZOOM_ONE_YEAR]: 1,
    [ChartDateZoom.CHART_ZOOM_TWO_YEAR]: 2,
    [ChartDateZoom.CHART_ZOOM_THREE_YEAR]: 3,
    [ChartDateZoom.CHART_ZOOM_FIVE_YEAR]: 5,
    [ChartDateZoom.CHART_ZOOM_TEN_YEAR]: 10,
    [ChartDateZoom.CHART_ZOOM_FIFTEEN_YEAR]: 15,
};
/** Mirrors `UniverseQuartileChartParams.MAX_PERIODS`: more boxes than this is unreadable. */
export const MAX_PERIODS = 24;
export const FREQUENCY_PERIODS_PER_YEAR = {
    [UniverseQuartileChartFrequency.MONTHLY]: 12,
    [UniverseQuartileChartFrequency.QUARTERLY]: 4,
    [UniverseQuartileChartFrequency.YEARLY]: 1,
};
/** Frequencies the control offers, coarsest last. */
export const FREQUENCY_OPTIONS = [
    { label: 'Monthly', value: UniverseQuartileChartFrequency.MONTHLY },
    { label: 'Quarterly', value: UniverseQuartileChartFrequency.QUARTERLY },
    { label: 'Yearly', value: UniverseQuartileChartFrequency.YEARLY },
];
/**
 * Periods per year for metric frequencies coarser than monthly.
 *
 * The endpoint rejects a chart frequency finer than the metric's own, and these are the only
 * frequencies coarse enough for that to bite. A metric reporting monthly or finer is absent here
 * and allows every option; so is an unrecognized frequency, which is left for the endpoint to
 * judge rather than guessed at.
 */
export const COARSE_METRIC_PERIODS_PER_YEAR = {
    monthly: 12,
    bimonthly: 6,
    quarterly: 4,
    quarterly_dec: 4,
    quarterly_nov: 4,
    quarterly_oct: 4,
    market_quarterly: 4,
    semi_yearly: 2,
    yearly: 1,
    market_yearly: 1,
};
/** The universe must be a list of funds, so the modal only offers the tabs that hold them. */
export const UNIVERSE_SECURITY_GROUP_TABS = [SECURITYLIST_GROUP_MULTI, FUND];
/**
 * Categories the universe modal leaves out
 */
export const UNIVERSE_HIDDEN_CATEGORIES = {
    [FUND]: ['Types', 'Styles', 'Styles (Morn)', 'Domicile'],
    [SECURITYLIST_GROUP_MULTI]: ['Stock Screens'],
};
export const LATEST_CHART_DATA_MODE = 'latest';
export const HISTORICAL_CHART_DATA_MODE = 'historical';
/** Feeds the metric selector the fund metric menu rather than the whole calc registry. */
export const FUND_METRIC_SEARCH_TYPE = FUND_CALC;
